export const DATA_PAGINATE = [30, 50, 80, 100, 150, 200, 250, 400, 500, 1000]
